import { render } from "./DocumentFormView.vue?vue&type=template&id=222a1b10"
import script from "./DocumentFormView.vue?vue&type=script&lang=js"
export * from "./DocumentFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__